import { render, staticRenderFns } from "./InvoiceAdd.vue?vue&type=template&id=142ba2be&scoped=true"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAdd.vue?vue&type=style&index=0&id=142ba2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ba2be",
  null
  
)

export default component.exports